export default __webpack_public_path__ + "media/images/btn-icon4-851406f9e6d444e37cc15355b594a93c.png";